import React, {useState} from 'react'
import {
    getLocalStorageItem,
    getPathBack,
    objectLang,
    setCookieOfFolder,
    setLocalStorageItem
} from "../functions"
import {SortWindowClass} from "../elements/SortWindowClass"
import {useNavigate, useParams} from "react-router-dom"
import {useHttp} from "../hooks/http.hook"
import config from "../config.json"
import {LoaderClass} from "../elements/LoaderClass"

export const SortWindowPage = () => {

    const navigate = useNavigate()
    const lang = objectLang().language
    const [show, setShow] = useState(true)
    const {request, loading} = useHttp()
    const folderId = useParams().id
    const folderContent = getLocalStorageItem(folderId)
    const page = getLocalStorageItem('page')

    const closeHandler = () => {
        setShow(false)
    }

    const sortHandler = async (sortName, order) => {
        setLocalStorageItem(`sort-${folderId}`, sortName)
        setLocalStorageItem(`order-${folderId}`, order)
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        if (page === 'FolderPage') {
            try {
                const data = await request(
                    `${host}/api/folder/set-sort`,
                    'POST',
                    {folderId, sortName, order})
                if (data.status === 200) {
                    folderContent.sort = sortName
                    folderContent.order = order
                    setCookieOfFolder(folderContent)
                    navigate(`/${lang.lang}/folder/open/${folderContent.parent}`)
                }
            } catch (e) {
                navigate(getPathBack())
            }
        } else {
            setLocalStorageItem(`sort-G-${folderId}`, sortName)
            setLocalStorageItem(`order-G-${folderId}`, order)
            navigate(`/${lang.lang}/google-drive/open/${folderContent.parent}`)
        }
    }

    const sortName = getLocalStorageItem(`sort-${folderId}`) || getLocalStorageItem(`sort-G-${folderId}`)
    const order = getLocalStorageItem(`order-${folderId}`) || getLocalStorageItem(`order-G-${folderId}`)

    if (loading) {
        return (<LoaderClass/>)
    }

    return (
        <>
            <SortWindowClass
                lang={lang}
                show={show}
                closeHandler={closeHandler}
                sortHandler={sortHandler}
                sortName={sortName}
                order={order}
            />
        </>
    )
}